import Back from './karten/back.png'
import Eichel0 from './karten/eichel0.gif';
import Eichel1 from './karten/eichel1.gif';
import Eichel2 from './karten/eichel2.gif';
import Eichel3 from './karten/eichel3.gif';
import Eichel4 from './karten/eichel4.gif';
import Eichel5 from './karten/eichel5.gif';
import Eichel6 from './karten/eichel6.gif';
import Eichel7 from './karten/eichel7.gif';
import Eichel8 from './karten/eichel8.gif';
import Rosen0 from './karten/rosen0.gif';
import Rosen1 from './karten/rosen1.gif';
import Rosen2 from './karten/rosen2.gif';
import Rosen3 from './karten/rosen3.gif';
import Rosen4 from './karten/rosen4.gif';
import Rosen5 from './karten/rosen5.gif';
import Rosen6 from './karten/rosen6.gif';
import Rosen7 from './karten/rosen7.gif';
import Rosen8 from './karten/rosen8.gif';
import Schellen0 from './karten/schellen0.gif';
import Schellen1 from './karten/schellen1.gif';
import Schellen2 from './karten/schellen2.gif';
import Schellen3 from './karten/schellen3.gif';
import Schellen4 from './karten/schellen4.gif';
import Schellen5 from './karten/schellen5.gif';
import Schellen6 from './karten/schellen6.gif';
import Schellen7 from './karten/schellen7.gif';
import Schellen8 from './karten/schellen8.gif';
import Schilten0 from './karten/schilten0.gif';
import Schilten1 from './karten/schilten1.gif';
import Schilten2 from './karten/schilten2.gif';
import Schilten3 from './karten/schilten3.gif';
import Schilten4 from './karten/schilten4.gif';
import Schilten5 from './karten/schilten5.gif';
import Schilten6 from './karten/schilten6.gif';
import Schilten7 from './karten/schilten7.gif';
import Schilten8 from './karten/schilten8.gif';

const CardDirectory = {
  'back':Back,
  'EichelnAs':Eichel0,
  'EichelnKoenig':Eichel1,
  'EichelnOber':Eichel2,
  'EichelnUnder':Eichel3,
  'EichelnBanner':Eichel4,
  'EichelnNeun':Eichel5,
  'EichelnAcht':Eichel6,
  'EichelnSieben':Eichel7,
  'EichelnSechs':Eichel8,
  'RosenAs':Rosen0,
  'RosenKoenig':Rosen1,
  'RosenOber':Rosen2,
  'RosenUnder':Rosen3,
  'RosenBanner':Rosen4,
  'RosenNeun':Rosen5,
  'RosenAcht':Rosen6,
  'RosenSieben':Rosen7,
  'RosenSechs':Rosen8,
  'SchellenAs':Schellen0,
  'SchellenKoenig':Schellen1,
  'SchellenOber':Schellen2,
  'SchellenUnder':Schellen3,
  'SchellenBanner':Schellen4,
  'SchellenNeun':Schellen5,
  'SchellenAcht':Schellen6,
  'SchellenSieben':Schellen7,
  'SchellenSechs':Schellen8,
  'SchiltenAs':Schilten0,
  'SchiltenKoenig':Schilten1,
  'SchiltenOber':Schilten2,
  'SchiltenUnder':Schilten3,
  'SchiltenBanner':Schilten4,
  'SchiltenNeun':Schilten5,
  'SchiltenAcht':Schilten6,
  'SchiltenSieben':Schilten7,
  'SchiltenSechs':Schilten8
 }

 export default CardDirectory;